<template>
    <Alert
      v-if="message?.content"
      variant="light"
      class="w-full"
      :style="{ 'background-color': message.colorBackground }"
      :closeable="true"
      :on-close="onClose"
    >
      <div class="prose max-w-none text-sm" :style="{ 'color': message.colorText }" v-html="message?.content || ''" />
    </Alert>
  </template>

<script setup>
import _ from 'lodash-es';
import { useEnumStore } from '@stores/enum';
import Alert from "@components/ui/alert";

const props = defineProps({
  type: {
    type: String,
    required: true
  }
});

const enums = useEnumStore();
const loaded = ref(false);
const message = ref(null);
const cookie = useCookie(`info-alert`, { default: () => [] });


const setupInfos = (infos = []) => {
  if (!infos || !infos.length) {
    return;
  }

  let messages = _.filter(infos || [], info => info?.type === props.type && !cookie.value.includes(info.id));
  if (_.isEmpty(messages)) {
    messages = _.filter(infos || [], info => info?.type === 'all' && !cookie.value.includes(info.id));
  }
  if (!_.isEmpty(messages)) {
    message.value = _.head(messages);
  }
}

watch(() => enums.infos, setupInfos);

onMounted(() => {
  nextTick(() => {
    setupInfos(enums.infos || []);
    loaded.value = true;
  });
});

const onClose = () => {
  if (message.value?.id) {
    cookie.value = [...cookie.value, message.value?.id];
    message.value = null;
  }
}

</script>
